import React from "react";

const CPP_Compiler = () => {
  return (
    <div>
      <h1>CPP_Compiler Component</h1>
      <p>Content for CPP_Compiler goes here...</p>
    </div>
  );
};

export default CPP_Compiler;
